import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import Delete from "../../../assets/images/delete.svg";
import { WalletMA } from "boa-sdk-ts";
import { useCopyAddress } from "../../../hooks/copyAddress";
import { useTranslation } from "react-i18next";
import { useHistory, withRouter } from "react-router-dom";
import { addressFormat } from "../../../utils/WalletUtils";

const WalletBox = (props) => {
  const [copyText, CopyContactAddress] = useCopyAddress();
  const { walletList, setAddressDropdown, DeleteAddress, currentAddress } =
    props;
  const { accounts } = WalletMA.instance();
  const { t } = useTranslation();
  const history = useHistory();

  //add new account
  const handleOpenKeysModal = () => {
    setAddressDropdown(false);
    history.push("/add-new-account");
  };

  //select change account
  const handleChangeAccount = (info) => {
    setAddressDropdown(false);
    accounts.selected_index = accounts.items.findIndex(
      (m) => m.address.toString() === info.address
    );
  };

  // console.log("WalletBox WalletList Info : " + walletList);

  if (!walletList) {
    return (
      <div className="accounts_list">
        <Button
          value=""
          onClick={handleOpenKeysModal}
          className="addnew"
          disablegutters="true"
        >
          <AddIcon /> {t("Add_New")}
        </Button>
      </div>
    );
  }

  return (
    <div className="accounts_list">
      <Button
        value=""
        onClick={handleOpenKeysModal}
        className="addnew"
        disablegutters="true"
      >
        <AddIcon /> {t("Add_New")}
      </Button>
      <ul>
        {walletList.map((info, index) => (
          <li
            key={index}
            className={currentAddress === info.address ? "active" : ""}
          >
            <div
              className="address"
              onClick={() =>
                handleChangeAccount(info, info.name ? info.name : info.address)
              }
              {...(info.name !== info.address ? { title: info.address } : {})}
            >
              <p>
                {info && info.name
                  ? info.name.length < 24
                    ? info.name
                    : addressFormat(info.name)
                  : addressFormat(info.address)}
              </p>
            </div>
            <div className="actions">
              <button onClick={() => CopyContactAddress(info.address)}>
                <i
                  className={
                    copyText === info.address
                      ? "fa fa-clone active"
                      : "fa fa-clone"
                  }
                  aria-hidden="true"
                />
              </button>
              <button onClick={() => DeleteAddress(info.name, false)}>
                <img alt="Delete" src={Delete} />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default withRouter(WalletBox);
